// JavaScript Document

//SPサイト
$(function(){
  var $panel = $('#js-popout-panel'); //パネル
  var DURATION = 200; //アニメーションのスピード
  //メニューボタンのイベント
  $('#js-popout').on('click', function(){
    $panel.fadeIn(DURATION);
  });
  //閉じるボタンのイベント
  $('#js-popout-close, .nav-item').on('click', function(){
    $panel.fadeOut(DURATION);
  });
});

$(document).ready(function () {
	 $("#js-popout-close, .nav-item a").click(function(event) {
	 $("#js-popout-panel").collapse('hide');
	 });
});  


$(function(){
  $('.menu-trigger').on('click',function(){
    $(this).toggleClass('active');
    $('.g-nav').slideToggle();
  });
});




//FAQ
$(function() {
	function demo01() {
		$(this).next().slideToggle(300);
	}
	$(".simple .toggle").click(demo01);

	function demo02() {
		$(this).toggleClass("active").next().slideToggle(300);
	}
	$(".switch .toggle").click(demo02);
});



//スムーススクロール
$(function () {
	// #で始まるアンカーをクリックした場合に処理
	$('a[href^=#]').click(function () {
		// スクロールの速度
		var speed = 600; // ミリ秒
		// アンカーの値取得
		var href = $(this).attr("href");
		// 移動先を取得
		var target = $(href == "#" || href == "" ? 'html' : href);
		// 移動先を数値で取得
		var position = target.offset().top;
		// スムーススクロール
		$('body,html').animate({
			scrollTop: position
		}, speed, 'swing');
		return false;
	});
});


//スクロールしてトップ
$(function() {
    var pageTop = $('.page_top_bt');
    pageTop.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 600) {
            pageTop.fadeIn();
        } else {
            pageTop.fadeOut();
        }
    });
    pageTop.click(function () {
        $('body, html').animate({scrollTop:0}, 500, 'swing');
        return false;
    });
});

$(function() {
  // 置換の対象とするclass属性。
  var $elem = $('.js-image-switch');
  // 置換の対象とするsrc属性の末尾の文字列。
  var sp = '_sp.';
  var pc = '_pc.';
  // 画像を切り替えるウィンドウサイズ。
  var replaceWidth = 768;

  function imageSwitch() {
    // ウィンドウサイズを取得する。
    var windowWidth = parseInt($(window).width());

    // ページ内にあるすべての`.js-image-switch`に適応される。
    $elem.each(function() {
      var $this = $(this);
      // ウィンドウサイズが768px以上であれば_spを_pcに置換する。
      if(windowWidth >= replaceWidth) {
        $this.attr('src', $this.attr('src').replace(sp, pc));

      // ウィンドウサイズが768px未満であれば_pcを_spに置換する。
      } else {
        $this.attr('src', $this.attr('src').replace(pc, sp));
      }
    });
  }
  imageSwitch();

  // 動的なリサイズは操作後0.2秒経ってから処理を実行する。
  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      imageSwitch();
    }, 200);
  });
});
